import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';
import { Row, Col } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { FormControlLabel, Typography, Button, Radio, RadioGroup, Select } from '@material-ui/core';

import Logo from '../../../images/logo.png';


import './registration.style.css'

class Registration extends Component {
    constructor(props) {
        super(props);
       // console.log(this.props);
        if (this.props.email && this.props.code) {
            this.state = {
                name: '',
                password: '',
                showPassword: false,
                country: "",
                city: "",
                type: "2",
                email: this.props.email,
                code: this.props.code,
                error: '',
                errorMessage: '',
                allCities: []
            }
        } else {
            this.state = {
                name: this.props.location.state.profileObj.name,
                password: '',
                showPassword: false,
                country: "",
                city: "",
                type: "2",
                email: this.props.location.state.profileObj.email,
                code: this.props.location.state.accessToken,
                error: '',
                errorMessage: '',
                provider: "google"
            }
        }
    }
    renderCountris() {
        return (
            this.props.data.countries.map(country => {
                return (
                    <option value={country.id}>{country.name}</option>
                );
            })
        );
    }
    componentDidMount() {
        if (this.props.data) {

        }
    }
    render() {
        if (this.props.data.loading) {
            return <div>Loading ...</div>
        }
        const handleChange = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });
        };
        const handelChangeContries = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value , allCities : [] });

           if(this.props.data)
           { this.props.data.countries.map(country => {
                    if (country.id === event.target.value) {
                        this.setState({ ...this.state,[prop]: event.target.value ,allCities: country.cities })
                    }
            })
            }
        }
        const handleClickShowPassword = () => {
            this.setState({ ...this.state, showPassword: !this.state.showPassword });
        };
        const handleMouseDownPassword = event => {
            event.preventDefault();
        };
        const handleChangeRadio = event => {
            this.setState({ ...this.state, type: event.target.value });
        };
        const checkName = (name) => {
            if (name.length < 4 || name.length > 32) {
                this.setState({ ...this.state, errorMessage: 'The user name must be between 4 and 32 characters long.' });
                return false;

            } else {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
        }
        const CheckPassword = (inputtxt) => {
            var passw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
            if (inputtxt.match(passw)) {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
            else {
                this.setState({ ...this.state, errorMessage: 'The password must contains at least 8 characters that are uppercase and lowercase letters , special characters and numbers.' });
                return false;
            }
        }
        const CheckcountryAndCity = () => {
            if (!this.state.country || !this.state.city) {
                this.setState({ ...this.state, errorMessage: 'Country and City is Required.' });
                return false;
            }
            else {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
        }

        return (
            <div className="container-custom pt-10">
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        if (checkName(this.state.name) && CheckPassword(this.state.password) && CheckcountryAndCity()) {
                            if (this.state.provider) {
                                this.props.mutate({
                                    variables: {
                                        name: this.state.name,
                                        password: this.state.password,
                                        countries_id: this.state.country,
                                        cities_id: this.state.city,
                                        user_type_id: this.state.type,
                                        email: this.state.email,
                                        pin_code: "",
                                        token: this.state.code,
                                        provider: this.state.provider

                                    }
                                }).then((res) => {
                                    this.setState({ ...this.state, error: res.data.register.Status.message })
                                    localStorage.setItem('jwt',JSON.stringify(res.data.register));
                                    if(res.data.register.user.typeName === 'employer'){
                                        this.props.history.push({
                                            pathname: '/companyProfileReg'
                                        });
                                    }
                                    else
                                    {
                                        this.props.history.push({
                                            pathname: '/homepage'
                                        });
                                    }
                                }).catch((err) => this.setState({ ...this.state, error: "Check your internet connection" }));
                            } else {
                                this.props.mutate({
                                    variables: {
                                        name: this.state.name,
                                        password: this.state.password,
                                        countries_id: this.state.country,
                                        cities_id: this.state.city,
                                        user_type_id: this.state.type,
                                        email: this.state.email,
                                        pin_code: this.state.code,
                                        token: "",
                                        provider: ""
                                    }
                                }).then((res) => {
                                    this.setState({ ...this.state, error: res.data.register.Status.message })
                                    localStorage.setItem('jwt',JSON.stringify(res.data.register));
                                    if(res.data.register.user.typeName === 'employer'){
                                        this.props.history.push({
                                            pathname: '/companyProfileReg'
                                        });
                                    }
                                    else
                                    {
                                        this.props.history.push({
                                            pathname: '/homepage'
                                        });
                                    }
                                }).catch((err) => this.setState({ ...this.state, error: "Check your internet connection" }));
                            }
                        }
                    }}
                    className="container" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px" />
                    </div>
                    <div className="pb-3">
                        <Typography variant="h4" color="primary" >Registration Form</Typography>
                    </div>
                    <div className="pt-1 pb-3">
                        <Typography variant="subtitle1" className="text-dark">Please complete the following data to complete your profile</Typography>
                    </div>
                    <TextField
                        fullWidth
                        label="User Name*"
                        color="primary"
                        variant="outlined"
                        value={this.state.name}
                        onChange={handleChange('name')}
                    />
                    <FormControl fullWidth className="mt-3" variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password*</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={this.state.showPassword ? 'text' : 'password'}
                            value={this.state.password}
                            onChange={handleChange('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}
                        />
                    </FormControl>
                    <Row>
                        <Col xs={6}>
                            <FormControl fullWidth className="mt-3" variant="outlined">
                                <InputLabel htmlFor="countries-select">
                                    Country*
                                </InputLabel>
                                <Select
                                    value={this.state.country}
                                    onChange={handelChangeContries('country')}
                                    labelWidth="55"
                                    inputProps={{
                                        name: "Countries",
                                        id: 'countries-select',
                                    }}
                                >
                                    {this.renderCountris()}
                                </Select>
                            </FormControl>
                        </Col>
                        <Col xs={6}>
                            <FormControl fullWidth className="mt-3" variant="outlined">
                                <InputLabel htmlFor="cities-select">
                                    City*
                                </InputLabel>
                                <Select
                                    value={this.state.city}
                                    onChange={handleChange('city')}
                                    labelWidth="35"
                                    inputProps={{
                                        name: "cities",
                                        id: 'cities-select',
                                    }}
                                >
                                    {(this.state.allCities)?
                                        this.state.allCities.map(city => {
                                            return (
                                                <option value={city.id}>{city.name}</option>
                                            );
                                        }): ''
                                    }
                                </Select>
                            </FormControl>
                        </Col>
                        <Col>
                            <Typography variant="subtitle1" className="text-dark">Register as:</Typography>
                        </Col>
                        <Col xs={12}>
                            <RadioGroup aria-label="type" name="gender2" value={this.state.type} onChange={handleChangeRadio}>
                                <FormControlLabel
                                    className="d-inline-block"
                                    value="2"
                                    control={<Radio color="primary" />}
                                    label="Applicant"
                                    labelPlacement="Applicant"
                                    defaultValue
                                />
                                <FormControlLabel
                                    className="d-inline-block"
                                    value="1"
                                    control={<Radio color="primary" />}
                                    label="Employer"
                                    labelPlacement="Employer"
                                />
                            </RadioGroup>
                        </Col>
                        <Col xs={12}>
                            <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                        </Col>
                        <Col xs={12} className="text-center">
                            <Button size="large" type="submit" variant="contained" className="btn-orange-gradiant pr-5 pl-5" >Get Started</Button>
                        </Col>
                    </Row>
                </form>
            </div>
        ); 
    }
}
const GET_CONTRIES_AND_CITIES = gql`
query{
    countries{
      id
      name
    cities{
      id
      name
      code
    }
    }
  } 
`

const REGISTRATION = gql`
mutation( $name : String ! $password : Password ! $countries_id : Int ! $cities_id : Int ! $user_type_id : Int !  $email : Email ! $pin_code : String !  $token : String  $provider : String ){
    register(data:
       {
        newUserInput:{
            name : $name
            password : $password
            countries_id : $countries_id
            cities_id :  $cities_id
            user_type_id : $user_type_id
        }
          verifyPinCodeInput:{
              email : $email
              pin_code : $pin_code
          }
          SocialiteInput:{
            token : $token
            provider : $provider
          }
       }
    ){
     BearerTokenResponse{
        access_token
        token_type
      }
      user{
        id
        name
        typeName
        company{
            id
            name
            website_url
            description
            logo{
                url
            }
        }
      }
      Status{
        message
        code
        check
        title
      }
    }
  }
`

export default compose(graphql(GET_CONTRIES_AND_CITIES), graphql(REGISTRATION))(withRouter(Registration));